import { SectionHeader } from "./SectionHeader";
import useReveal from "@/lib/useReveal";
import { useSection } from "@/lib/SiteContent";
import { imageUrl } from "@/lib/api";

const DEFAULT_PHOTOS = [
  "https://images.unsplash.com/photo-1618844035942-1178d8a34ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBzdGFuZGluZyUyMGJ5JTIwdGhlJTIwc2VhJTIwbWluaW1hbGlzdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzc4NDI3OTY4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1676124189678-f4bcde297c18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjb3VwbGUlMjBzdGFuZGluZyUyMGJ5JTIwdGhlJTIwc2VhJTIwbWluaW1hbGlzdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzc4NDI3OTY4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1769605322812-cbd19f0ab2da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxzY2FuZGluYXZpYW4lMjByb2NreSUyMGNvYXN0JTIwb2NlYW58ZW58MHx8fHwxNzc4NDI3OTY4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1761095596674-546f146fa03d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwZWxlZ2FudCUyMHdlZGRpbmclMjB0YWJsZSUyMHNldHRpbmd8ZW58MHx8fHwxNzc4NDI3OTY4fDA&ixlib=rb-4.1.0&q=85",
];

export const Gallery = () => {
  const gallery = useSection("gallery", { image_ids: [] });
  const ref = useReveal();
  const ids = gallery.image_ids || [];
  const photos = ids.length > 0 ? ids.map((id) => imageUrl(id)) : DEFAULT_PHOTOS;

  return (
    <section
      id="galleri"
      data-testid="gallery-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#EAEDDC]/40"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="Kapittel IV"
          title="Øyeblikk"
          subtitle="Et lite knippe bilder fra vår reise sammen."
          testId="gallery"
        />
        <div ref={ref} className="reveal grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((src, idx) => (
            <div
              key={idx}
              data-testid={`gallery-photo-${idx}`}
              className={`img-zoom ${
                idx % 5 === 0 ? "md:col-span-2 aspect-[4/3]" : "aspect-square"
              }`}
            >
              <img src={src} alt={`Galleribilde ${idx + 1}`} className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>
        {ids.length === 0 && (
          <p className="text-center mt-12 text-sm font-light text-[#68919B] italic">
            Flere bilder kommer snart…
          </p>
        )}
      </div>
    </section>
  );
};
